// ============================================================================
// RECOVERY-CASE-001 — Recovery Cases (Master List)
// ============================================================================
// Bank-driven enforcement + asset realisation cases — repo, auction, SARFAESI.
// Thin wrapper around <LitigationCasesScreen /> that pins category=RECOVERY.

import React from 'react';
import LitigationCasesScreen from 'components/modules/litigation-module/LitigationCasesScreen';

interface Props {
  tabId?: string;
  moduleName?: string;
}

const RecoveryCasesScreen: React.FC<Props> = ({ tabId, moduleName }) => (
  <LitigationCasesScreen
    tabId={tabId}
    moduleName={moduleName}
    category="RECOVERY"
  />
);

export default RecoveryCasesScreen;
